import React, { useState, useEffect, useCallback, useRef } from "react";
import CommonContainer from "../Container/CommonContainer";
import "../../Complaint.css";
import "bootstrap/dist/css/bootstrap.min.css";
import ReactDatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useSelector, useDispatch } from "react-redux";
import * as PartnerService from '../../Services/Partner/PartnerService';
import LoadingSpinnerComponent from "../Loader/LoadingSpinnerComponent";
import toast from "react-hot-toast";
import { FaCashRegister, FaDownload, FaSearch, FaSpinner } from "react-icons/fa";
import { Calendar } from "lucide-react";
import { LoadingMessage } from "../../Common/CommonVariables";
import "./CreditCustomerPartnerComponent.css"; // Assuming you have some custom styles

import { store } from '../../Store/store';
import { currencySymbols } from '../../Common/CommonVariables';

const CreditCustomerPartnerComponent = () => {
    const dispatch = useDispatch();
    const selectedOrg = useSelector((state) => state.selectedOrganization);

    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [loading, setLoading] = useState(false);
    const [transactions, setTransactions] = useState([]);
    const [dateRangeOption, setDateRangeOption] = useState("MTD");

    const startDateRef = useRef(null);
    const endDateRef = useRef(null);

    const userInfo = store.getState();

    const handleDateRangeChange = (e) => {
        const selected = e.target.value;
        setDateRangeOption(selected);

        const today = new Date();
        let start = null;
        let end = new Date();

        switch (selected) {
            case "MTD":
                start = new Date(today.getFullYear(), today.getMonth(), 1);
                end = new Date();
                break;
            case "Last Month":
                start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
                end = new Date(today.getFullYear(), today.getMonth(), 0);
                break;
            case "Last 2 Months":
                start = new Date(today.getFullYear(), today.getMonth() - 2, 1);
                end = new Date(today.getFullYear(), today.getMonth(), 0);
                break;
            case "Last 3 Months":
                start = new Date(today.getFullYear(), today.getMonth() - 3, 1);
                end = new Date(today.getFullYear(), today.getMonth(), 0);
                break;
            case "Custom":
                start = null;
                end = null;
                break;
            default:
                break;
        }

        setStartDate(start);
        setEndDate(end);
    };

    const getFirstDayOfMonth = () => {
        const today = new Date();
        return new Date(today.getFullYear(), today.getMonth(), 1);
    };

    // Set initial default dates on first load
    useEffect(() => {
        setStartDate(getFirstDayOfMonth());
        setEndDate(new Date());
    }, []);

    // Fetch data only after org, startDate, and endDate are all available
    useEffect(() => {
        if (selectedOrg && startDate && endDate) {
            fetchPartnerTransaction();
        }
    }, [selectedOrg, startDate, endDate]);

    const formatDate = (date) => {
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const fetchPartnerTransaction = useCallback(() => {
        if (!selectedOrg) {
            toast.error("No organization selected.");
            return;
        }

        if (!startDate || !endDate) {
            toast.error("Start and End date cannot be empty.");
            return;
        }

        if (startDate > endDate) {
            toast.error("Start date cannot be after end date.");
            return;
        }

        if (endDate > new Date()) {
            toast.error("End date cannot be in the future.");
            return;
        }

        setLoading(true);

        const requestData = {
            fromDate: formatDate(startDate),
            toDate: formatDate(endDate),
            // organizationId: selectedOrg?.MHL_Org_Id__c || "0",
            organizationId: "0"
        };

        PartnerService.CC_GetPartnerStatemntTransactionData(requestData)
            .then(({ data }) => {
                if (data.IsSuccess) {
                    setTransactions(data.Data.data || []);
                } else {
                    setTransactions([]);
                }
            })
            .catch(() => {
                toast.error("Something went wrong.");
                setTransactions([]);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [selectedOrg, startDate, endDate]);

    const handleSearchClick = () => {
        fetchPartnerTransaction();
    };

    return (
        <CommonContainer
        icon={<FaCashRegister size={20}/>}
            heading={<>Transactions</>}
            buttonText=""
            onButtonClick={() => { }}
        >
            {/* {loading && <LoadingSpinnerComponent />} */}

            <div className="d-flex align-items-center justify-content-between mb-2">
                <div className="d-flex w-100 transaction-search align-items-center gap-2">
                    {/* <div className="position-relative">
                        <label>Start Date:</label>&nbsp;
                        <ReactDatePicker
                            selected={startDate}
                            onChange={(date) => setStartDate(date)}
                            className="form-control"
                            dateFormat="dd-MM-yyyy"
                            placeholderText="Select Start Date"
                            ref={startDateRef}
                        />
                        <Calendar
                            size={20}
                            className="position-absolute"
                            style={{ right: "10px", top: "50%", transform: "translateY(-50%)" }}
                            onClick={() => startDateRef.current.setFocus()}
                        />
                    </div>

                    <div className="position-relative">
                        <label>End Date:</label>&nbsp;
                        <ReactDatePicker
                            selected={endDate}
                            onChange={(date) => setEndDate(date)}
                            className="form-control"
                            dateFormat="dd-MM-yyyy"
                            placeholderText="Select End Date"
                            ref={endDateRef}
                        />
                        <Calendar
                            size={20}
                            className="position-absolute"
                            style={{ right: "10px", top: "50%", transform: "translateY(-50%)" }}
                            onClick={() => endDateRef.current.setFocus()}
                        />
                    </div> */}

                    {/* Date Range Dropdown */}
                    <select
                        className="form-select custom-select"
                        value={dateRangeOption}
                        onChange={handleDateRangeChange}
                        style={{ maxWidth: "200px" }}
                    >
                        <option>MTD</option>
                        <option>Last Month</option>
                        <option>Last 2 Months</option>
                        <option>Last 3 Months</option>
                        <option>Custom</option>
                    </select>

                    {/* Custom Date Pickers */}
                    {dateRangeOption === "Custom" && (
                        <>
                            <div className="position-relative">
                                <ReactDatePicker
                                    selected={startDate}
                                    onChange={setStartDate}
                                    className="form-control"
                                    dateFormat="dd-MM-yyyy"
                                    placeholderText="Start Date"
                                    ref={startDateRef}
                                    maxDate={new Date()}
                                />
                                <Calendar
                                    size={20}
                                    className="position-absolute"
                                    style={{ right: "10px", top: "50%", transform: "translateY(-50%)" }}
                                    onClick={() => startDateRef.current.setFocus()}
                                />
                            </div>

                            <div className="position-relative">
                                <ReactDatePicker
                                    selected={endDate}
                                    onChange={setEndDate}
                                    className="form-control"
                                    dateFormat="dd-MM-yyyy"
                                    placeholderText="End Date"
                                    ref={endDateRef}
                                    maxDate={new Date()}
                                />
                                <Calendar
                                    size={20}
                                    className="position-absolute"
                                    style={{ right: "10px", top: "50%", transform: "translateY(-50%)" }}
                                    onClick={() => endDateRef.current.setFocus()}
                                />
                            </div>
                        </>
                    )}

                    <button
                        className="btn custom-sumbitbtn transaction-gobtn d-flex align-items-center justify-content-center"
                        style={{ width: "38px", height: "35px", padding: "0" }}
                        onClick={handleSearchClick}
                        disabled={loading}
                    >
                        {loading ? <FaSpinner className="fa-spin" /> : <b>GO</b>}
                    </button>
                    {loading ?
                        <LoadingMessage />
                        : null}
                </div>
            </div>

            <div className="table-responsive" style={{ overflowY: "auto", maxHeight: "650px" }}>
                <table className="table table-bordered custom-table">
                    <thead>
                        <tr>
                            <th>Bill Date</th>
                            <th>VID</th>
                            <th>Patient Name</th>
                            <th>Location</th>
                            <th>Gross</th>
                            <th>Net</th>
                            <th>Received</th>
                            <th>Due</th>
                            <th>Pay Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {transactions.length > 0 ? (
                            transactions.map((item, index) => (
                                <tr key={index}>
                                    <td className="text-nowrap text-center">{item.billDate}</td>
                                    <td className="text-nowrap text-center">{item.visitNumber}</td>
                                    <td className="text-nowrap">{item.patientName}</td>
                                    <td className="text-nowrap">{item.location}</td>
                                    <td className="text-nowrap text-end">{currencySymbols[userInfo?.Partner_Account_Details?.CurrencyIsoCode]}{item.grossAmount}</td>
                                    <td className="text-nowrap text-end">{currencySymbols[userInfo?.Partner_Account_Details?.CurrencyIsoCode]}{item.netAmount}</td>
                                    <td className="text-nowrap text-end text-success">{currencySymbols[userInfo?.Partner_Account_Details?.CurrencyIsoCode]}{item.amountReceived}</td>
                                    <td className="text-nowrap text-end text-danger">{currencySymbols[userInfo?.Partner_Account_Details?.CurrencyIsoCode]}{item.dueAmount}</td>
                                    <td className="text-nowrap text-center">
                                        <span className={`badge ${item.paymentStatus === 'Completed' ? 'bg-success' : 'bg-warning'}`}>
                                            {item.paymentStatus}
                                        </span>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="9" className="text-center">No Transaction Found</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </CommonContainer>
    );
};

export default CreditCustomerPartnerComponent;

// import React, { useState, useEffect, useCallback, useRef } from "react";
// import CommonContainer from "../Container/CommonContainer";
// import "../../Complaint.css";
// import "bootstrap/dist/css/bootstrap.min.css";
// import ReactDatePicker from 'react-datepicker';
// import 'react-datepicker/dist/react-datepicker.css';
// import { useSelector, useDispatch } from "react-redux";
// import * as PartnerService from '../../Services/Partner/PartnerService';
// import LoadingSpinnerComponent from "../Loader/LoadingSpinnerComponent";
// import toast from "react-hot-toast";
// import { FaDownload, FaSearch, FaSpinner } from "react-icons/fa";
// import "react-datepicker/dist/react-datepicker.css";
// import { Calendar } from "lucide-react";

// const CreditCustomerPartnerComponent = () => {
//     const dispatch = useDispatch();
//     const selectedOrg = useSelector((state) => state.selectedOrganization);

//     const [startDate, setStartDate] = useState(new Date());
//     const [endDate, setEndDate] = useState(new Date());
//     const [loading, setLoading] = useState(false);
//     const [SearchLoading, setSearchLoading] = useState(false);
//     const [transactions, setTransactions] = useState([]);

//     // Function to calculate the first day of the current month (MTD)
//     const getFirstDayOfMonth = () => {
//         const today = new Date();
//         return new Date(today.getFullYear(), today.getMonth(), 1);
//     };

//     // Set default start date to the first day of the current month and end date to today
//     useEffect(() => {
//         setStartDate(getFirstDayOfMonth());
//         setEndDate(new Date());
//     }, []);

//     // Fetch partner transactions when the organization changes
//     useEffect(() => {
//         if (selectedOrg) {
//             // Call the API to fetch transactions when organization changes
//             fetchPartnerTransaction();
//         }
//     }, [selectedOrg]);  // Only trigger on organization change

//     const fetchPartnerTransaction = useCallback(() => {
//         if (!selectedOrg) {
//             toast.error("No organization selected.");
//             return;
//         }
//         if (startDate == null || endDate == null) {
//             toast.error("Date can't be null/empty");
//             return;
//         }
//         if (startDate > endDate) {
//             toast.error("Start date cannot be after end date");
//             return;
//         }
//         if (endDate > new Date()) {
//             toast.error("End date cannot be of future");
//             return;
//         }

//         setLoading(true);

//         const requestData = {
//             fromDate: formatDate(startDate),
//             toDate: formatDate(endDate),
//             // organizationId: selectedOrg.MHL_Org_Id__c
//             organizationId: "0"
//         };

//         PartnerService.CC_GetPartnerStatemntTransactionData(requestData)
//             .then(({ data }) => {
//                 if (data.IsSuccess) {
//                     setTransactions(data.Data.data);
//                 } else {
//                     setTransactions([]);
//                 }
//             })
//             .catch(() => {
//                 toast.error("Something went wrong.");
//             })
//             .finally(() => {
//                 setLoading(false);
//             });
//     }, [selectedOrg]);

//     const startDateRef = useRef(null);
//     const endDateRef = useRef(null);

//     function formatDate(date) {
//         const d = new Date(date);
//         const year = d.getFullYear();
//         const month = String(d.getMonth() + 1).padStart(2, '0');
//         const day = String(d.getDate()).padStart(2, '0');
//         return `${year}-${month}-${day}`;
//     }

//     const handleSearchClick = () => {
//         // Trigger fetch on search button click
//         fetchPartnerTransaction();
//     };

//     return (
//         <CommonContainer
//             heading={<>Transactions
//             {/* {selectedOrg?.MHL_Organization_Name && <> (<b>{selectedOrg.MHL_Organization_Name}</b>)</>} */}
//             </>}
//             buttonText=""
//             onButtonClick={() => { }}
//         >
//             {loading && <LoadingSpinnerComponent />}
//             <div className="d-flex align-items-center justify-content-between mb-2">
//                 <div className="d-flex align-items-center gap-2">
//                     <div className="position-relative">
//                         <label>Start Date:</label>&nbsp;
//                         <ReactDatePicker
//                             selected={startDate}
//                             onChange={(date) => setStartDate(date)}  // Handle date change
//                             className="form-control"
//                             dateFormat="dd-MM-yyyy"
//                             placeholderText="Select Start Date"
//                             ref={startDateRef}
//                         />
//                         <Calendar
//                             size={20}
//                             className="position-absolute"
//                             style={{ right: "10px", top: "50%", transform: "translateY(-50%)" }}
//                             onClick={() => startDateRef.current.setFocus()}
//                         />
//                     </div>

//                     <div className="position-relative">
//                         <label>End Date:</label>&nbsp;
//                         <ReactDatePicker
//                             selected={endDate}
//                             onChange={(date) => setEndDate(date)}  // Handle date change
//                             className="form-control"
//                             dateFormat="dd-MM-yyyy"
//                             placeholderText="Select End Date"
//                             ref={endDateRef}
//                         />
//                         <Calendar
//                             size={20} className="position-absolute"
//                             style={{ right: "10px", top: "50%", transform: "translateY(-50%)" }}
//                             onClick={() => endDateRef.current.setFocus()}
//                         />
//                     </div>

//                     <button
//                         className="btn btn-success d-flex align-items-center justify-content-center"
//                         style={{ width: "38px", height: "35px", padding: "0" }}
//                         onClick={handleSearchClick}  // Trigger fetch on search button click
//                         disabled={loading}
//                     >
//                         {loading ? <FaSpinner className="fa-spin" /> : <FaSearch />}
//                     </button>
//                 </div>
//             </div>

//             <div className="table-responsive" style={{ overflowY: "auto", maxHeight: "650px" }}>
//                 <table className="table table-bordered custom-table">
//                     <thead>
//                         <tr>
//                             <th>Bill Date</th>
//                             <th>Visit No</th>
//                             <th>Patient</th>
//                             <th>Location</th>
//                             <th>Gross</th>
//                             <th>Net</th>
//                             <th>Received</th>
//                             <th>Due</th>
//                             <th>Pay Status</th>
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {transactions.length > 0 ? (
//                             transactions.map((item, index) => (
//                                 <tr key={index}>
//                                     <td className="text-nowrap text-center">{item.billDate}</td>
//                                     <td className="text-nowrap text-center">{item.visitNumber}</td>
//                                     <td className="text-nowrap">{item.patientName}</td>
//                                     <td className="text-nowrap">{item.location}</td>
//                                     <td className="text-nowrap text-end">{currencySymbols[userInfo?.Partner_Account_Details?.CurrencyIsoCode]}{item.grossAmount}</td>
//                                     <td className="text-nowrap text-end">{currencySymbols[userInfo?.Partner_Account_Details?.CurrencyIsoCode]}{item.netAmount}</td>
//                                     <td className="text-nowrap text-end text-success">{currencySymbols[userInfo?.Partner_Account_Details?.CurrencyIsoCode]}{item.amountReceived}</td>
//                                     <td className="text-nowrap text-end text-danger">{currencySymbols[userInfo?.Partner_Account_Details?.CurrencyIsoCode]}{item.dueAmount}</td>
//                                     <td className="text-nowrap text-center">
//                                         <span className={`badge ${item.paymentStatus === 'Completed' ? 'bg-success' : 'bg-warning'}`}>
//                                             {item.paymentStatus}
//                                         </span>
//                                     </td>
//                                 </tr>
//                             ))
//                         ) : (
//                             <tr>
//                                 <td colSpan="9" className="text-center">No Transaction Found</td>
//                             </tr>
//                         )}
//                     </tbody>
//                 </table>
//             </div>
//         </CommonContainer>
//     );
// };

// export default CreditCustomerPartnerComponent;
